import instance from "../root.api";

export const getFamilyRequest = id => instance.get(`/families/${id}`);

export const updateFamilyRequest = ({ id, ...data }) =>
  instance.put(`/families/${id}`, data);
